export default {
  ANDROID: 'android',
  IOS: 'ios',
  NON_MOBILE: 'non-mobile',
  OTHER_MOBILE: 'other-mobile',
};
